import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { useLocation } from 'react-router-dom';

/*
      +--------------------------------+  ^
      |         Fixed Header           |  |
      +--------------------------------+  |
      |                                |  |
      |                                |  |
      |                                |  |
      |         Growing main           |  | min-height: 100vh
      |                                |  |
      |                                |  |
      |                                |  |
      +--------------------------------+  |
      |                                |  |
      |         Fixed Footer           |  |
      |                                |  |
      +--------------------------------+  v
*/
const DefaultLayout: React.FC = ({ children }) => {
  const location = useLocation();
  const pathName = location.pathname.split('/')[1];

  return (
    <div className="d-flex flex-column min-vh-100">
      <Header />
      <main data-gi={`onboarding_${pathName}`} className="flex-grow-1 flex-shrink-1">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default DefaultLayout;
